/**
 * 资源管理中心.
 */

/**
 * 获取帧.
 *
 * @param {string} key 名称.
 * @param {number} n 数量.
 * @param {number} 开始的值.
 */
// const getFrames = (key, n, start = 0) => {
//   const frames = []
//   for (let i = start; i < n + start; i += 1) {
//     frames.push(`${key}${i}`)
//   }
//   return frames
// }
// 自动加载资源文件
const modulesFiles = require.context('./img/main', false, /\.(png|jpg)$/)
const resources = []
modulesFiles.keys().reduce((key, modulePath) => {
  const value = modulesFiles(modulePath)
  resources.push({ name: modulePath.match(/\.\/(.*?)\./)[1], url: value })
  return resources
}, {})

// 场景
const scenes = {
  scene1: {
    x: 0,
    y: 0,
    width: 7184,
    height: 750
  }
}
const bg = []
const fg = []
for (let i = 0; i < 6; i++) {
  bg.push({
    name: `bg_0${i + 1}`,
    position: { x: i * 1197, y: 0 }, // 坐标
    anchor: { x: 0, y: 0 }, // 锚点
    size: { width: 1197, height: 750 } // 大小
  })
  fg.push({
    name: `花草_0${i + 1}`,
    position: { x: i * 1197, y: 0 },
    anchor: { x: 0, y: 0 },
    size: { width: 1197, height: 750 }
  })
}
// 加载精灵
// 资源名称: {
//   position: { x: x坐标, y: y坐标 }, // 必须，资源坐标
//   anchor: { x: 0, y: 0 }, // 必须，锚点位置
//   size: { width: 大小, height: 大小 }, // 必须，精灵尺寸
//   animations: [{ // 非必须，精灵动画
//     delay: 0,
//     // frames: [‘资源1’, '资源2'], // 非必须，帧动画
//     // frameRate: 2, // 非必须，帧数量
//     // duration: 1, // 非必须，动画时长默认1
//     from: { y: 321 },
//     // yoyo: true表示时间轴每次重复时交替来回播放 https://www.tweenmax.com.cn/api/tweenmax/yoyo
//     // repeat: 重复次数 -1 表示一直重复.
//     // ease: 运动曲线.
//     to: { y: 340, yoyo: true, repeat: -1, ease: 'easeOut' }
// }],
//   touch: {
//     eventName: '事件名称',
//     params: { // 点击参数
//     }
//   }
// },
const sceneSprites = [
  {
    name: '野餐',
    position: { x: 111, y: 531 },
    anchor: { x: 0, y: 0 },
    size: { width: 646, height: 219 }
  },
  {
    name: '摩天轮下的男孩',
    position: { x: 469, y: 505 },
    anchor: { x: 0, y: 0 },
    size: { width: 67, height: 119 },
    touch: {
      eventName: 'childrenClick',
      params: {
        index: 0
      }
    }
  },
  {
    name: '摩天轮',
    position: { x: 392, y: 20 },
    anchor: { x: 0, y: 0 },
    size: { width: 597, height: 610 }
  },
  {
    name: '男孩1',
    position: { x: 478, y: 115 },
    anchor: { x: 0, y: 0 },
    size: { width: 85, height: 93 },
    touch: {
      eventName: 'childrenClick',
      params: {
        index: 14
      }
    }
  },
  {
    name: '女孩+糖果',
    position: { x: 1136, y: 505 },
    anchor: { x: 0, y: 0 },
    size: { width: 96, height: 117 },
    animations: [{
      delay: 0,
      duration: 1,
      from: { x: 1136 },
      // yoyo: true表示时间轴每次重复时交替来回播放
      // repeat: 重复次数 -1 表示一直重复.
      // ease: 运动曲线.
      to: { x: 1156, yoyo: true, repeat: 1 }
    }],
    touch: {
      eventName: 'childrenClick',
      params: {
        index: 1
      }
    }
  },
  {
    name: '玩偶',
    position: { x: 991, y: 238 },
    anchor: { x: 0, y: 0 },
    size: { width: 230, height: 380 }
  },
  {
    name: '红色的气球',
    position: { x: 1200, y: 321 },
    anchor: { x: 0, y: 0 },
    size: { width: 75, height: 220 },
    animations: [{
      delay: 0,
      duration: 3,
      from: { y: 330 },
      // yoyo: true表示时间轴每次重复时交替来回播放
      // repeat: 重复次数 -1 表示一直重复.
      // ease: 运动曲线.
      to: { y: 361, yoyo: true, repeat: -1, ease: 'easeOut' }
    }],
    touch: {
      eventName: 'advClick',
      params: {
        index: 1
      }
    }
  },
  {
    name: '彩蛋',
    position: { x: 1140, y: 311 },
    anchor: { x: 0, y: 0 },
    size: { width: 40, height: 50 },
    touch: {
      eventName: 'advClick',
      params: {
        index: 1
      }
    }
  },
  {
    name: '手指',
    position: { x: 499, y: 535 },
    anchor: { x: 0, y: 0 },
    size: { width: 79, height: 69 },
    animations: [{
      delay: 0,
      duration: 1,
      from: { width: 79, height: 69 },
      // yoyo: true表示时间轴每次重复时交替来回播放
      // repeat: 重复次数 -1 表示一直重复.
      // ease: 运动曲线.
      to: { width: 99, height: 89, yoyo: true, repeat: -1, ease: 'easeOut' }
    }]
  },
  {
    name: '母亲',
    position: { x: 1244, y: 391 },
    anchor: { x: 0, y: 0 },
    size: { width: 123, height: 246 }
  },
  {
    name: '女孩2',
    position: { x: 1409, y: 331 },
    anchor: { x: 0, y: 0 },
    size: { width: 85, height: 114 },
    touch: {
      eventName: 'childrenClick',
      params: {
        index: 2
      }
    }
  },
  {
    name: '玩玩具',
    position: { x: 1815, y: 551 },
    anchor: { x: 0, y: 0 },
    size: { width: 86, height: 91 },
    animations: [{
      delay: 0,
      duration: 1,
      // from: { x: 1815 },
      to: { x: 1615 }
    }],
    touch: {
      eventName: 'childrenClick',
      params: {
        index: 3
      }
    }
  }
]
const sprites = {
  scene1: [
    ...bg,
    ...sceneSprites,
    {
      name: '滑梯',
      position: { x: 1407, y: 59 },
      anchor: { x: 0, y: 0 },
      size: { width: 1119, height: 593 }
    },
    {
      name: '风筝 2',
      position: { x: 1907, y: 39 },
      anchor: { x: 0, y: 0 },
      size: { width: 130, height: 110 },
      animations: [{
        delay: 0,
        duration: 2,
        // yoyo: true表示时间轴每次重复时交替来回播放
        // repeat: 重复次数 -1 表示一直重复.
        // ease: 运动曲线.
        to: { x: 1909, y: 69, yoyo: true, repeat: -1 }
      }],
      touch: {
        eventName: 'advClick',
        params: {
          index: 2
        }
      }
    },
    {
      name: '彩蛋',
      position: { x: 1840, y: 30 },
      anchor: { x: 0, y: 0 },
      size: { width: 40, height: 50 },
      touch: {
        eventName: 'advClick',
        params: {
          index: 2
        }
      }
    },
    {
      name: '男孩3',
      position: { x: 2337, y: 396 },
      anchor: { x: 0, y: 0 },
      size: { width: 85, height: 111 },
      touch: {
        eventName: 'childrenClick',
        params: {
          index: 4,
          options: {
            position: { x: 20, y: 10 }
          }
        }
      }
    },
    {
      name: '拍照妈妈',
      position: { x: 2527, y: 436 },
      anchor: { x: 0, y: 0 },
      size: { width: 126, height: 175 }
    },
    {
      name: '猫(2)',
      position: { x: 2641, y: 626 },
      anchor: { x: 0, y: 0 },
      size: { width: 154, height: 58 }
    },
    {
      name: '云',
      position: { x: 3132, y: 152 },
      anchor: { x: 0, y: 0 },
      animations: [{
        delay: 0,
        duration: 3,
        from: { x: 3132, y: 152 },
        // yoyo: true表示时间轴每次重复时交替来回播放
        // repeat: 重复次数 -1 表示一直重复.
        // ease: 运动曲线.
        to: { x: 3162, y: 152, yoyo: true, repeat: -1 }
      }],
      size: { width: 391, height: 131 },
      touch: {
        eventName: 'advClick',
        params: {
          index: 3
        }
      }
    },
    {
      name: '彩蛋',
      position: { x: 3092, y: 140 },
      anchor: { x: 0, y: 0 },
      size: { width: 40, height: 50 },
      touch: {
        eventName: 'advClick',
        params: {
          index: 3
        }
      }
    },
    {
      name: '冰淇淋车',
      position: { x: 2638, y: 223 },
      anchor: { x: 0, y: 0 },
      size: { width: 936, height: 402 }
    },
    {
      name: '爸爸',
      position: { x: 3188, y: 396 },
      anchor: { x: 0, y: 0 },
      size: { width: 93, height: 281 }
    },
    {
      name: '冰淇淋车男孩',
      position: { x: 3263, y: 509 },
      anchor: { x: 0, y: 0 },
      size: { width: 113, height: 154 },
      touch: {
        eventName: 'childrenClick',
        params: {
          index: 5,
          options: {
            position: { x: 20, y: 10 }
          }
        }
      }
    },
    {
      name: '旋转木马',
      position: { x: 3332, y: 92 },
      anchor: { x: 0, y: 0 },
      size: { width: 690, height: 565 }
    },
    {
      name: '旋转木马男孩',
      position: { x: 3411, y: 382 },
      anchor: { x: 0, y: 0 },
      size: { width: 70, height: 112 },
      touch: {
        eventName: 'childrenClick',
        params: {
          index: 6,
          options: {
            position: { x: 20, y: 10 }
          }
        }
      }
    },
    {
      name: '旋转木马母亲',
      position: { x: 3651, y: 380 },
      anchor: { x: 0, y: 0 },
      size: { width: 45, height: 88 },
      touch: {
        eventName: 'childrenClick',
        params: {
          index: 7
        }
      }
    },
    {
      name: '旋转木马母亲(1)',
      position: { x: 3604, y: 323 },
      anchor: { x: 0, y: 0 },
      size: { width: 150, height: 209 }
    },
    {
      name: '小狗',
      position: { x: 3870, y: 405 },
      anchor: { x: 0, y: 0 },
      size: { width: 87, height: 71 }
    },
    {
      name: '小兔子女孩',
      position: { x: 4246, y: 531 },
      anchor: { x: 0, y: 0 },
      size: { width: 91, height: 110 },
      touch: {
        eventName: 'childrenClick',
        params: {
          index: 8
        }
      }
    },
    {
      name: '手推车',
      position: { x: 4040, y: 350 },
      anchor: { x: 0, y: 0 },
      size: { width: 436, height: 296 }
    },
    // '女孩(2)': {
    //   position: { x: 5248, y: 509 },
    //   anchor: { x: 0, y: 0 },
    //   size: { width: 90, height: 119 }
    // },
    {
      name: '喷泉',
      position: { x: 4414, y: 179 },
      anchor: { x: 0, y: 0 },
      size: { width: 1040, height: 449 }
    },
    {
      name: '风筝',
      position: { x: 4344, y: 174 },
      anchor: { x: 0, y: 0 },
      size: { width: 119, height: 102 },
      animations: [{
        delay: 0,
        duration: 1,
        from: { y: 174 },
        // yoyo: true表示时间轴每次重复时交替来回播放
        // repeat: 重复次数 -1 表示一直重复.
        // ease: 运动曲线.
        to: { y: 194, yoyo: true, repeat: -1, ease: 'easeOut' }
      }],
      touch: {
        eventName: 'advClick',
        params: {
          index: 4
        }
      }
    },
    {
      name: '彩蛋',
      position: { x: 4294, y: 164 },
      anchor: { x: 0, y: 0 },
      size: { width: 40, height: 50 },
      touch: {
        eventName: 'advClick',
        params: {
          index: 4
        }
      }
    },
    {
      name: '吹泡泡的小孩',
      position: { x: 4451, y: 544 },
      anchor: { x: 0, y: 0 },
      size: { width: 84, height: 107 },
      touch: {
        eventName: 'childrenClick',
        params: {
          index: 9
        }
      }
    },
    {
      name: '泡泡',
      position: { x: 3959, y: 0 },
      anchor: { x: 0, y: 0 },
      animations: [{
        delay: 0,
        duration: 1,
        from: { x: 3959, y: 0 },
        // yoyo: true表示时间轴每次重复时交替来回播放
        // repeat: 重复次数 -1 表示一直重复.
        // ease: 运动曲线.
        to: { x: 3949, y: -10, yoyo: true, repeat: -1 }
      }],
      size: { width: 1892, height: 552 }
    },
    {
      name: '长椅',
      position: { x: 4459, y: 523 },
      anchor: { x: 0, y: 0 },
      size: { width: 283, height: 145 }
    },
    {
      name: '父亲拿包',
      position: { x: 4481, y: 437 },
      anchor: { x: 0, y: 0 },
      size: { width: 212, height: 246 }
    },
    // '图层 229 拷贝': {
    //   position: { x: 5109, y: 278 },
    //   anchor: { x: 0, y: 0 },
    //   size: { width: 36, height: 39 },
    //   touch: {
    //     eventName: 'advClick',
    //     params: {
    //       index: 4
    //     }
    //   }
    // },
    {
      name: '喝水',
      position: { x: 4611, y: 454 },
      anchor: { x: 0, y: 0 },
      size: { width: 78, height: 142 },
      touch: {
        eventName: 'childrenClick',
        params: {
          index: 10,
          options: {
            position: { x: 20, y: 20 }
          }
        }
      }
    },
    {
      name: '帐篷',
      position: { x: 5154, y: 182 },
      anchor: { x: 0, y: 0 },
      size: { width: 1111, height: 436 }
    },
    {
      name: '骑单车',
      position: { x: 5746, y: 461 },
      anchor: { x: 0, y: 0 },
      size: { width: 144, height: 152 },
      animations: [{
        delay: 0.65,
        duration: 0.35,
        from: { x: 5746 },
        to: { x: 5446 }
      }],
      touch: {
        eventName: 'childrenClick',
        params: {
          index: 12,
          options: {
            position: { x: 40, y: 20 }
          }
        }
      }
    },
    // 小熊: {
    //   position: { x: 5908, y: 592 },
    //   anchor: { x: 0, y: 0 },
    //   size: { width: 84, height: 116 },
    //   touch: {
    //     eventName: 'childrenClick',
    //     params: {
    //       index: 11
    //     }
    //   }
    // },
    {
      name: '舞台小丑表演',
      position: { x: 5996, y: 148 },
      anchor: { x: 0, y: 0 },
      size: { width: 504, height: 497 }
    },
    {
      name: '小朋友',
      position: { x: 6305, y: 382 },
      anchor: { x: 0, y: 0 },
      size: { width: 122, height: 140 },
      touch: {
        eventName: 'childrenClick',
        params: {
          index: 13,
          options: {
            position: { x: 40, y: 10 }
          }
        }
      }
    },
    {
      name: '人',
      position: { x: 6040, y: 519 },
      anchor: { x: 0, y: 0 },
      size: { width: 95, height: 208 }
    },
    {
      name: '图层 227',
      position: { x: 6262, y: 545 },
      anchor: { x: 0, y: 0 },
      size: { width: 128, height: 205 }
    },
    {
      name: '曲线 1',
      position: { x: 6367, y: 599 },
      anchor: { x: 0, y: 0 },
      size: { width: 102, height: 151 },
      touch: {
        eventName: 'childrenClick',
        params: {
          index: 15,
          options: {
            position: { x: 40, y: 0 }
          }
        }
      }
    },
    {
      name: '猫',
      position: { x: 6473, y: 567 },
      anchor: { x: 0, y: 0 },
      size: { width: 63, height: 87 }
    },
    {
      name: '爸爸带孩子',
      position: { x: 6552, y: 357 },
      anchor: { x: 0, y: 0 },
      size: { width: 100, height: 281 },
      touch: {
        eventName: 'childrenClick',
        params: {
          index: 16,
          options: {
            position: { x: 30, y: 0 }
          }
        }
      }
    },
    {
      name: '组 2',
      position: { x: 6653, y: 417 },
      anchor: { x: 0, y: 0 },
      size: { width: 172, height: 224 },
      touch: {
        eventName: 'childrenClick',
        params: {
          index: 17,
          options: {
            position: { x: 0, y: 90 }
          }
        }
      }
    },
    {
      name: '单车-点击业务',
      position: { x: 6862, y: 431 },
      anchor: { x: 0, y: 0 },
      size: { width: 219, height: 221 }
    },
    {
      name: '热气球',
      position: { x: 6862, y: 60 },
      anchor: { x: 0, y: 0 },
      size: { width: 155, height: 254 },
      animations: [{
        delay: 0,
        duration: 1,
        // yoyo: true表示时间轴每次重复时交替来回播放
        // repeat: 重复次数 -1 表示一直重复.
        // ease: 运动曲线.
        to: { x: 6862, y: 80, yoyo: true, repeat: -1 }
      }],
      touch: {
        eventName: 'advClick',
        params: {
          index: 5
        }
      }
    },
    {
      name: '彩蛋',
      position: { x: 6882, y: 280 },
      anchor: { x: 0, y: 0 },
      size: { width: 40, height: 50 },
      touch: {
        eventName: 'advClick',
        params: {
          index: 5
        }
      }
    },
    ...fg
  ]
}

const spriteAnimations = {
  // 精灵动画
}

const texts = {
}

// yoyo: true表示时间轴每次重复时交替来回播放
// repeat: 重复次数 -1 表示一直重复.
// ease: 运动曲线.
const textsAnimations = {
}

export {
  scenes,
  resources,
  sprites,
  spriteAnimations,
  texts,
  textsAnimations
}
